import type { EmbeddedAssetSquidexMetadata } from "~/fragments/image"

const RETINA_FILE_NAME_PATTERN = /[@_]2x(?![a-z0-9])/i
const STANDARD_FILE_NAME_PATTERN = /[@_]1x(?![a-z0-9])/i

type NamedAsset = Pick<EmbeddedAssetSquidexMetadata, "fileName">

export function isRetinaAsset(asset: NamedAsset): boolean {
  return RETINA_FILE_NAME_PATTERN.test(asset.fileName)
}

export function isStandardAsset(asset: NamedAsset): boolean {
  return STANDARD_FILE_NAME_PATTERN.test(asset.fileName)
}
